export const getSummaryRouteTitle = (t: any, fromText?: string, toText?: string): string => {
  return `${t("transport.from")} ${fromText ?? ""} - ${t("transport.to")} ${toText ?? ""}`;
};
